"use client";

import { BigCard } from "@jesus-central-church/ui";
import { SbBlokData, storyblokEditable } from "@storyblok/react/rsc";
import { SbBigCard } from "@storyblok/types/287435740670216/storyblok-components";
import { linkResolver } from "../../lib/storyblok";

type BigCardProperties = {
  blok: SbBigCard;
};

export function BigCardComponent({ blok }: BigCardProperties) {
  const link =
    blok.link === null || blok.link?.cached_url === ""
      ? undefined
      : linkResolver(blok.link);

  return (
    <BigCard
      {...storyblokEditable(blok as SbBlokData)}
      url={link}
      image={{
        url: blok.image.filename || "",
        alt: blok.image.alt || blok.title || "Card image",
      }}
      title={blok.title}
      description={blok.description}
      ctaText={blok.ctaText}
    />
  );
}
